import React from 'react';
import ToPeso from './ToPeso';

const ProgressBar = ({ totalPayments, remainingBalance, totalRepayments }) => {
  // Calculate the payment progress
  const paymentProgress = (totalPayments / totalRepayments) * 100;

  // Style for the progress bar
  const progressStyle = {
    width: `${paymentProgress}%`,
    backgroundColor: '#4CAF50',
    height: '30px',
    textAlign: 'center',
    lineHeight: '30px',
    color: 'white',
    borderRadius: '4px',
    maxWidth: '100%'
  };

  return (
    <div id="payment-progress" className="pbar">
      <div className="prog-text"><i className="fa-solid fa-bars-progress"></i> Progress</div>
      <div className="prog-num"><ToPeso amount={totalPayments} /> <span>/</span> <ToPeso amount={totalRepayments} /></div>
      <div className="bar" style={{ backgroundColor: '#bcbcbc', height: '30px', borderRadius: '4px', marginBottom: '10px' }}>
        <div style={progressStyle}>
          {paymentProgress.toFixed(2)}%
        </div>
      </div>
      <div className="balance">Balance: <ToPeso amount={remainingBalance} /></div>
    </div>
  );
};

export default ProgressBar;
